import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import navMeta from './navMeta'
import { trackRoute } from './history'
import { theme } from '../theme'
import LoginView from '../views/LoginView.vue'
import ProjectView from '../views/ProjectView.vue'
import NewView from '../views/NewView.vue'
import ChatView from '../views/ChatView.vue'
import SettingsView from '../views/SettingsView.vue'
import HelpView from '../views/HelpView.vue'
import SyncView from '../views/SyncView.vue'
import ManuelView from '../views/ManuelView.vue'
import AdminManuelView from '../views/admin/AdminManuelView.vue'
import AdminView from '../views/admin/AdminView.vue'
import AdminEngineEditView from '../views/admin/AdminEngineEditView.vue'
import AdminAgentSessionDetail from '../views/admin/AdminAgentSessionDetail.vue'
import AdminUserDetailView from '../views/admin/AdminUserDetailView.vue'
import AdminOrganisationDetailView from '../views/admin/AdminOrganisationDetailView.vue'
import AdminTeamDetailView from '../views/admin/AdminTeamDetailView.vue'
import AdminStockPlanDetailView from '../views/admin/AdminStockPlanDetailView.vue'
import AdminSpreadsheetView from '../views/admin/AdminSpreadsheetView.vue'
import AdminConversationsBrowser from '../views/admin/AdminConversationsBrowser.vue'
import AdminComparativeView from '../views/admin/AdminComparativeView.vue'
import features from '@/config/features'
import SupportCenterView from '../views/SupportCenterView.vue'
import SupportListView from '../views/SupportListView.vue'
import SupportTicketView from '../views/SupportTicketView.vue'
import FaqListView from '../views/FaqListView.vue'
import FaqDetailView from '../views/FaqDetailView.vue'
import LegalView from '../views/LegalView.vue'
import AboutView from '../views/AboutView.vue'
import ServiceUnavailableView from '../views/ServiceUnavailableView.vue'
import NotFoundView from '../views/NotFoundView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/cgv',
    name: 'cgv',
    component: LegalView,
    props: { src: '/legal/cgv.md' }
  },
  {
    path: '/politique-cookies',
    name: 'politique_cookies',
    component: LegalView,
    props: { src: '/legal/politique_cookies.md' }
  },
  {
    path: '/politique-confidentialite',
    name: 'politique_confidentialite',
    component: LegalView,
    props: { src: '/legal/politique_confidentialite.md' }
  },
  {
    path: '/mentions-legales',
    name: 'mentions_legales',
    component: LegalView,
    props: { src: '/legal/mentions_legales.md' }
  },
  {
    path: '/a-propos',
    name: 'about',
    component: AboutView,
    meta: { requiresAuth: true }
  },
  {
    path: '/',
    name: 'home',
    component: NewView,
    meta: { requiresAuth: true }
  },
  {
    path: '/new',
    name: 'new',
    component: NewView,
    meta: { requiresAuth: true }
  },
  {
    path: '/chat/:id',
    name: 'chat_detail',
    component: ChatView,
    meta: { requiresAuth: true }
  },
  {
    path: '/project/:id?',
    name: 'project_detail',
    component: ProjectView,
    meta: { requiresAuth: true }
  },
  {
    path: '/settings',
    name: 'settings',
    component: SettingsView,
    meta: { requiresAuth: true }
  },
  {
    path: '/support',
    name: 'support',
    component: SupportCenterView,
    meta: { requiresAuth: true, feature: 'support' }
  },
  // Tickets moved from /support/* to /tickets/*; keep old deep links (stored notifications) working
  { path: '/support/new', redirect: '/tickets/new' },
  { path: '/support/:id', redirect: '/tickets/:id' },
  {
    path: '/tickets',
    name: 'tickets',
    component: SupportListView,
    meta: { requiresAuth: true, feature: 'support' }
  },
  {
    path: '/tickets/new',
    name: 'ticket_new',
    component: SupportListView,
    props: { openNew: true },
    meta: { requiresAuth: true, feature: 'support' }
  },
  {
    path: '/tickets/:id',
    name: 'ticket_detail',
    component: SupportTicketView,
    meta: { requiresAuth: true, feature: 'support' }
  },
  {
    path: '/admin/tickets',
    name: 'admin_tickets',
    component: SupportListView,
    props: { admin: true },
    meta: { requiresAuth: true, feature: 'support' }
  },
  {
    path: '/admin/tickets/:id',
    name: 'admin_ticket_detail',
    component: SupportTicketView,
    props: { admin: true },
    meta: { requiresAuth: true, feature: 'support' }
  },
  {
    path: '/faq',
    name: 'faq',
    component: FaqListView,
    meta: { requiresAuth: true, feature: 'support' }
  },
  {
    path: '/faq/:slug',
    name: 'faq_detail',
    component: FaqDetailView,
    meta: { requiresAuth: true, feature: 'support' }
  },
  {
    path: '/help',
    name: 'help',
    component: HelpView,
    meta: { requiresAuth: true }
  },
  {
    path: '/sync',
    name: 'sync',
    component: SyncView,
    meta: { requiresAuth: true }
  },
  {
    path: '/manuel',
    name: 'manuel',
    component: ManuelView,
    meta: { requiresAuth: true }
  },
  {
    path: '/manuel/admin',
    name: 'manuel_admin',
    component: AdminManuelView,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin',
    name: 'admin',
    component: AdminView,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/engines/:id/edit',
    name: 'admin_engine_edit',
    component: AdminEngineEditView,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/agent-sessions/:id',
    name: 'admin_agent_session_detail',
    component: AdminAgentSessionDetail,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/users/:id',
    name: 'admin_user_detail',
    component: AdminUserDetailView,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/organisations/:id',
    name: 'admin_organisation_detail',
    component: AdminOrganisationDetailView,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/teams/:id',
    name: 'admin_team_detail',
    component: AdminTeamDetailView,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/stock-plans/:id',
    name: 'admin_stock_plan_detail',
    component: AdminStockPlanDetailView,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/files/:id/spreadsheet',
    name: 'admin_file_spreadsheet',
    component: AdminSpreadsheetView,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/legacy/conversations/:id?',
    name: 'admin_conversations_browser',
    component: AdminConversationsBrowser,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/test/comparative/:runId?',
    name: 'admin_comparative',
    component: AdminComparativeView,
    meta: { requiresAuth: true }
  },
  {
    path: '/service-unavailable',
    name: 'service_unavailable',
    component: ServiceUnavailableView
  },
  {
    path: '*',
    name: 'not_found',
    component: NotFoundView
  }
]

routes.forEach((route) => {
  if (route.name && navMeta[route.name]) route.meta = { ...route.meta, ...navMeta[route.name] }
})

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, _from, next) => {
  const isLoggedIn = !!store.getters['settings/accessToken']
  if (to.meta.requiresAuth && !isLoggedIn) {
    next(to.fullPath === '/' ? '/login' : { path: '/login', query: { redirect: to.fullPath } })
  } else if (to.path === '/login' && isLoggedIn) {
    next('/')
  } else if (to.meta.feature && !features[to.meta.feature]) {
    next('/')
  } else if (to.meta.staff && !store.getters['settings/isStaff']) {
    store.commit('chat/SHOW_NOTIFICATION', { type: 'error', message: 'Accès réservé au staff.' })
    next('/')
  } else {
    next()
  }
})

router.afterEach((to, from) => {
  trackRoute(from)
  const title = to.meta.title
  document.title = title ? `${title} · ${theme.brand.appName}` : theme.brand.appName
})

export default router
